import { ExtendsMainComponent } from '../extends/extends-main.component';

import { ViewChild } from '@angular/core';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { ConsentOidcComponent } from '../consent-oidc/consent-oidc.component';

import { TokenManager } from '../../service/web-api.service';

import { AuthService } from '../../service/auth.service';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

declare let gtag: any; // グローバル変数gtagを解決

export class ConsentOidcMainComponent extends ExtendsMainComponent {
  private confirmModal: ConfirmModalComponent;
  private waitModal: WaitModalComponent;
  private consentOidcComponent: ConsentOidcComponent;

  private authService: AuthService;

  // V2の判定
  public isV2: boolean;

  // 画面項目定義
  public clientName: string;
  public clientLogoUri: string;
  public oidcScopes: string[];
  public displayResourceName: string;
  /** リソース表示名(複数) */
  public displayResourceNames: string[];

  init(_consentOidcComponent: ConsentOidcComponent, _authService: AuthService,
    _waitModal: WaitModalComponent, _confirmModal: ConfirmModalComponent) {

    this.config();

    this.consentOidcComponent = _consentOidcComponent;
    this.authService = _authService;
    this.waitModal = _waitModal;
    this.confirmModal = _confirmModal;

    this.clientName = this.consentOidcComponent.clientName;
    this.clientLogoUri = this.consentOidcComponent.clientLogoUri;
    this.oidcScopes = this.consentOidcComponent.oidcScopes;
    this.displayResourceName = this.consentOidcComponent.displayResourceName;
    this.displayResourceNames = this.consentOidcComponent.displayResourceNames;

    this.isV2 = this.authService.isV2;
  }

  /**
   * イベント：次へ
   *
   */
  next() {
    // 引継ぎ項目
    this.consentOidcComponent.pageNo++;

    // 画面切り替え
    this.consentOidcComponent.directInjection();
  }

  /**
   * イベント：戻る
   */
  back() {
    // 引継ぎ項目
    this.consentOidcComponent.pageNo--;

    // 画面切り替え
    this.consentOidcComponent.directInjection();
  }

  /**
   * ユーザの同意可否をFormSubmitするメソッドです.
   * @param result ユーザの選択結果
   */
  submit(result: string) {
    this.waitModal.showModal();

    // 送信先URL
    let url = '';
    if (this.isV2) {
      url = environment.apiServerBaseUrl + '/v2/authorization/receiveconsent?' + TokenManager.getToken();
    } else {
      url = environment.apiServerBaseUrl + '/authorization/receiveconsent?' + TokenManager.getToken();
    }

    // パラメータ
    const param = { 'result': result };

    // submit実行
    this.onSubmit(url, param);

    this.waitModal.hideModal();
  }

  /**
   * 認可同意の処理を行うメソッドです．
   */
  consent() {
    this.submit('consent-oidc');
    // GAで集計する
    gtag('event', 'consent_oidc');
  }

  /**
   * 認可拒否の処理を行うメソッドです．
   */
  deny() {
    let message = '';
    this.consentOidcComponent.translateService.get('DENY_CONFIRMATION').subscribe((res: string) => {
      message = res;
    });
    let button = '';
    this.consentOidcComponent.translateService.get('DENY').subscribe((res: string) => {
      button = res;
    });
    this.confirmModal.showConfirmModal(message, button).subscribe(
      result => {
        if (result) {
          this.submit('deny');
        }
      }
    );
  }
}
